import { AppNS } from 'app';
import { omit } from 'lodash';
import { parseAgencyDocumentsResponse } from '../agency-documents/agency-documents-parsers';
import { ApiNS } from '../api';
import {
  parseJobData,
  parseLeadProposal,
} from '../common-parsers/common-parsers';

export const parseProjectLead = (data: AppNS.Params): AppNS.ProjectLead => {
  const documents = data?.jobLead?.documents || data?.documents || [];
  data.endDate = data.job.endDate;
  data.startDate = data.job.startDate;
  data.job = parseJobData({
    ...data.job,
    client: data.client,
    agency: data.agency,
  });
  data.proposal = parseLeadProposal(data.jobLead);
  data.type = data?.jobLead?.type || data?.type || '';
  data.files = documents ? parseAgencyDocumentsResponse(documents) : [];

  return data as AppNS.ProjectLead;
};

export const parseProposal = (data: AppNS.LeadProposal): AppNS.Params => {
  return {
    id: data.id,
    properties: {
      agencyId: data.agencyId,
      paymentArrangement: data.paymentArrangement,
      termsAndConditions: data.terms,
      description: data.services,
      detailsAboutPricing: data.pricingPolicy,
      estimatedBudget: data.budget,
      numberOfVisits: data.visits.map((visit) => {
        return [visit.permitNumber, visit.visits];
      }),
    },
  };
};

export const getEmptyProposal = () => {
  return {
    budget: '',
    id: '',
    isSend: false,
    pricingPolicy: '',
    services: '',
    terms: '',
    visits: [],
    paymentArrangement: 'event',
    files: [],
    specialInspections: {},
    type: 'regular',
  } as AppNS.LeadProposal;
};

export const prepareEventReportData = (
  data: ApiNS.AddEventRequestData
): ApiNS.AddEventRequest => {
  return {
    properties: {
      ...omit(data, 'pickedPermits'),
      permitInspectionIds: parsePermitsForEvent(data.pickedPermits),
    },
  };
};

export const prepareBookingData = (
  data: ApiNS.AddBookingRequestData
): ApiNS.AddBookingRequest => {
  return {
    properties: {
      ...omit(data, 'pickedPermits'),
      permitInspectionIds: parsePermitsForEvent(data.pickedPermits),
    },
  };
};

export const parsePermitsForEvent = (
  data: Array<AppNS.PickedPermit>
): { [key: string]: Array<string> } => {
  const output = {} as { [key: string]: Array<string> };
  data.forEach((permit: AppNS.PickedPermit) => {
    output[permit.id] = permit.inspections;
  });

  return output;
};

export const parseNewEventResponse = (data: AppNS.Params): AppNS.JobEventReport => {
  const output = {
    ...data.properties,
    id: data.id,
  };

  return output as unknown as AppNS.JobEventReport;
};
